export interface AppConfig {
    url: string;
    authUrl: string;
    webUrl: string;
    session: {
      warningDuration: number; //ms
      sessionTimeout: number; //ms
  };
}
export const CONFIG={
  apiUrl: 'http://localhost:8012/api',
  authUrl: '/authapi',
  webUrl: '',
  idleWarningTime: 900000, // 15 minute
  sessionTimeout: 1200000, // 20 minutes
};
